import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SnackService } from "./snack.service";

@Injectable()
export class AmmsasErrorHandler extends ErrorHandler {
    private readonly publicRoutes = ['/app/reset-password', '/app/verify-user'];

    constructor(
        private router: Router,
        private snackService: SnackService
    ) {
        super();
    }

    override handleError(error: any): void {
        const currentRoute = this.router.url;

        if (error?.status === 401) {
            console.error('401 error on route:', currentRoute);

            // Only redirect if the current route is not public
            if (!this.isPublicRoute(currentRoute)) {
                console.warn('Redirecting to login...');
                this.router.navigate(['app/login']);
            } else {
                console.error('Skipping login redirect for public route:', currentRoute);
            }
            return;
        }

        // Handle other errors
        this.snackService.showSnack(error?.message || 'An error occurred', 'Error', 'error');

        super.handleError(error);
    }

    private isPublicRoute(route: string): boolean {
        return this.publicRoutes.some(publicRoute => route.startsWith(publicRoute));
    }
}
